/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Finance_Payments_TitleInputs */

const en_finance_payments_title = /** @type {(inputs: Finance_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const pl_finance_payments_title = /** @type {(inputs: Finance_Payments_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatności`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Finance_Payments_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const finance_payments_title = /** @type {((inputs?: Finance_Payments_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Finance_Payments_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_finance_payments_title(inputs)
	return en_finance_payments_title(inputs)
});